<template>
    <div class="eligible-physician">
        <user-card :physician="physician" size="medium" :showRefCount="false" :showSpeciality="false">
            <div class="eligible-physician-hover-menu">
                <div class="card__cta">
                    <div v-bind="{ ...ctaProps, ...searchData }" @emitEvent="emitEvent($event)"></div>
                </div>
            </div>
        </user-card>
    </div>
</template>

<script>
    import { importComponents } from '~/helpers'
    import UserCard from 'components/page-elements/referrals/UserCard'
    import PhysicianMixin from 'mixins/PhysicianMixin'

    export default {
        mixins: [PhysicianMixin],

        components: {
            ...importComponents(require.context('components/page-elements/referrals-new-card')),
            UserCard,
        },

        props: {
            physician: { type: Object, required: true },
            searchData: { type: Object, required: false, default: () => {} },
        },
    }
</script>
